import apiClient from '../../../api/apiClient';
import { SYSTEM_REST_API_BASE_URL } from '../../../config';
const REST_API_BASE_URL = SYSTEM_REST_API_BASE_URL;

export const getAllUsers = () => apiClient.get(REST_API_BASE_URL + '/users');

export const saveProduct = (product) =>
  apiClient.post(REST_API_BASE_URL + '/product', product);

export const getUser = (accountid, id) =>
  apiClient.get(`${REST_API_BASE_URL}/account/${accountid}/user/${id}`);

export const getUserDetails = (userid) =>
  apiClient.get(`${REST_API_BASE_URL}/user/${userid}`);

export const updateUser = (id, user) =>
  apiClient.put(`${REST_API_BASE_URL}/user/${id}`, user);

export const getUsersByAccount = (id) =>
  apiClient.get(`${REST_API_BASE_URL}/account/${id}/users`);

export const getUsersByMessage = (id) =>
  apiClient.get(`${REST_API_BASE_URL}/message/${id}/users`);

export const getLoggedInUserProfile = () =>
  apiClient.get(`${REST_API_BASE_URL}/profile`);

export default apiClient;
